export default __webpack_public_path__ + "static/media/cambridgeenglish.cb9bfe2e.png";